<template>
    <v-card>
        <v-container>
            <v-row>
                <v-col cols="12" lg="3">
                    <v-select
                        v-model="filtersSelected"
                        outlined
                        multiple
                        clearable
                        small-chips
                        deletable-chips
                        :label="$vuetify.lang.t('$vuetify.alarm.filterby')"
                        hide-details
                        :items="[{ text: $vuetify.lang.t('$vuetify.alarm.alarmactive'), value: '0' }, { text: $vuetify.lang.t('$vuetify.alarm.alarmnotconsulted'), value: '1' }]"
                    >
                    </v-select>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="$vuetify.lang.t('$vuetify.alarm.search')"
                        outlined
                        hide-details
                        class="my-3"
                    ></v-text-field>
                    <v-navigation-drawer height="690" width="100%" permanent>
                        <v-treeview
                            ref="tree"
                            item-key="name"
                            dense
                            hoverable
                            activatable
                            open-on-click
                            transition
                            return-object
                            :items="prefilteredItems"
                            :search="search"
                            :active.sync="active"
                            :open="filteredItems"
                            @update:active="onUpdateActive"
                        >
                            <template v-slot:prepend="{ item, open, leaf }">
                                <v-icon :color="leaf && item.isactive ? 'red' : ''">
                                    {{ leaf ? 'mdi-alarm-light' : open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                            </template>
                            <template v-slot:label="node">
                                <div>{{ prepareNodeLabel(node) }}</div>
                            </template>
                        </v-treeview>
                        <div
                            v-if="(prefilteredItems.length === 0 && filtersSelected.length > 0) || (filteredItems.length === 0 && search !== '')"
                            class="text-h6 grey--text text--lighten-1 font-weight-light">
                            {{ $vuetify.lang.t('$vuetify.noDataText') }}
                        </div>
                    </v-navigation-drawer>
                </v-col>
                <v-col :align-self="(selected && !folderLoading) ? 'start' : 'center'">
                    <AlarmsDetailsCard v-if="selected && !folderLoading" :alarm="selected" :images="images"/>
                    <v-skeleton-loader v-else-if="selected && folderLoading" class="mx-auto" width="500" type="card"></v-skeleton-loader>
                    <div v-else class="text-h6 text-center grey--text text--lighten-1 font-weight-light">
                        {{ $vuetify.lang.t('$vuetify.alarm.selectanalarmfolder') }}
                    </div>
                </v-col>
            </v-row> 
        </v-container>
    </v-card>
</template>

<script>
const today = new Date()

import AlarmsDetailsCard from './Alarms/AlarmDetailsCard.vue';
import axios from 'axios';
import _ from 'lodash';
import { mapGetters } from 'vuex';
var tiff = require('tiff');

export default {
    name: "Alarms",
    components: {
        AlarmsDetailsCard
    },
    data() {
        return {
            folderLoading: true,
            filters: [
                { label: "Active", key: "isactive", value: true },
                { label: "Not consulted", key: "isconsulted", value: false },
            ],
            filtersSelected: [],
            months: [this.$vuetify.lang.t('$vuetify.alarm.january'), this.$vuetify.lang.t('$vuetify.alarm.february'), this.$vuetify.lang.t('$vuetify.alarm.march'), this.$vuetify.lang.t('$vuetify.alarm.april'), this.$vuetify.lang.t('$vuetify.alarm.may'), this.$vuetify.lang.t('$vuetify.alarm.june'), this.$vuetify.lang.t('$vuetify.alarm.july'), 
            this.$vuetify.lang.t('$vuetify.alarm.august'), this.$vuetify.lang.t('$vuetify.alarm.september'), this.$vuetify.lang.t('$vuetify.alarm.october'), this.$vuetify.lang.t('$vuetify.alarm.november'), this.$vuetify.lang.t('$vuetify.alarm.december')],
            active: [],
            currentYearChildren: [],
            pastYearChildren: [],
            oldChildren : [],
            images: [],
            alarms: [],
            search: "",
            currentYearChildrenFiltered: [],
            pastYearChildrenFiltered: [],
            oldChildrenFiltered: [],
        }
    },
    computed: {
        ...mapGetters({user: "StateUser"}),

        items () {
            return [
                {
                    name: "" + today.getFullYear(),
                    children: this.currentYearChildren,
                    root: true
                },
                {
                    name: "" + (today.getFullYear() -1),
                    children: this.pastYearChildren,
                    root: true
                },
                {   
                    name: this.$vuetify.lang.t('$vuetify.alarm.before') +' '+ Number(today.getFullYear() - 1) + ' : ' + this.oldChildren.length +' '+ this.$vuetify.lang.t('$vuetify.alarm.alarm') + (this.oldChildren.length > 1 ? "s" : ""),
                    children: this.oldChildren,
                    root: true
                },
            ]
        },
        selected() {
            return this.active.length > 0 && !('children' in this.active[0]) ? this.active[0] : undefined;
        },
        filteredItems() {
            return this.search !== "" || this.filtersSelected.length > 0 ? Object.values(this.$refs.tree.nodes).filter(node => !this.$refs.tree.excludedItems.has(node.item.name)).map(node => node.item) : [];
        },
        prefilteredItems() {
            return [
                {
                    name: "" + today.getFullYear(),
                    children: this.currentYearChildrenFiltered,
                    root: true
                },
                {
                    name: "" + (today.getFullYear() -1),
                    children: this.pastYearChildrenFiltered,
                    root: true
                },
                {   
                    name: this.$vuetify.lang.t('$vuetify.alarm.before') +' '+ Number(today.getFullYear() - 1) + ' : ' + this.oldChildren.length +' '+ this.$vuetify.lang.t('$vuetify.alarm.alarm') + (this.oldChildren.length > 1 ? "s" : ""),
                    children: this.oldChildren.filter(this.customFilter),
                    root: true
                },
            ]
        }
    },
    watch: {
        filtersSelected(newFilters) {
            let query = {};
            for (const i of newFilters) {
                query[this.filters[i].key] = String(this.filters[i].value);
            }
            if (!_.isEqual(query, this.$route.query)) this.$router.replace({ query: query });
            let currentYearChildrenCopy = _.cloneDeep(this.currentYearChildren);
            let pastYearChildrenCopy = _.cloneDeep(this.pastYearChildren);
            currentYearChildrenCopy.forEach(child => child.children = child.children.filter(this.customFilter));
            pastYearChildrenCopy.forEach(child => child.children = child.children.filter(this.customFilter));
            this.currentYearChildrenFiltered = currentYearChildrenCopy;
            this.pastYearChildrenFiltered = pastYearChildrenCopy;
        },
    },

    mounted() {
        this.getAlarms();
    },

    methods: {
        compareAlarmDate(alarmA, alarmB) { // alarm name must be written in this pattern : 99999.Z_yyyymmdd_hhmmss
            return - alarmA.name.substring(8).localeCompare(alarmB.name.substring(8)) // compare on date and hour only
        },
        prepareNodeLabel(node) {
            if (!('root' in node.item) && !node.leaf) {
                let newLength = this.$refs.tree.nodes[node.item.name].children.filter(child => child.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) > -1).length;
                let newName = node.item.name.replace(/\d+/, newLength);
                if (newLength <= 1) {
                    let alarmTrad = this.$vuetify.lang.t('$vuetify.alarm.alarm');
                    const regex = new RegExp(alarmTrad + '(s)?');
                    newName = newName.replace(regex, alarmTrad);
                }
                return newName;
            }
            return node.item.name;
        },
        customFilter(item) {
            let ret = true;
            for (const filterIndex of this.filtersSelected) {
                const { key, value } = this.filters[filterIndex];
                ret &= item[key] == value;
            }
            return ret
        },
        async getAlarms() {
            try {
                const res = await axios.get('alarms/'+this.user.orga);
                if (res.status == 200) {
                    let alarms = res.data;

                    alarms.sort(this.compareAlarmDate);
    
                    let currentYearChildren = [], pastYearChildren = [], oldChildren = [];
    
                    for (let i = 0; i < today.getMonth() + 1; i++) {
                        currentYearChildren.push({
                            name: "",
                            children: []
                        })
                    }
                    for (let i = 0; i < 12; i++) {
                        pastYearChildren.push({
                            name: "",
                            children: []
                        })
                    }

                    for (const index in alarms) {
                        if (alarms[index].name.substring(8, 12) == today.getFullYear()) {
                            currentYearChildren[currentYearChildren.length - 1 - (alarms[index].name.substring(12, 14) - 1)].children.push(alarms[index]);
                        } else if (alarms[index].name.substring(8, 12) == today.getFullYear() - 1) {
                            pastYearChildren[pastYearChildren.length - 1 - (alarms[index].name.substring(12, 14) - 1)].children.push(alarms[index]);
                        } else {
                            oldChildren.push(alarms[index]);
                        }
                    }

                    currentYearChildren.forEach((child, index) => {
                        child.name = this.months[currentYearChildren.length - 1 - index] + " : " + child.children.length + " "+this.$vuetify.lang.t('$vuetify.alarm.alarm') + (child.children.length > 1 ? "s" : "");
                    })
                    pastYearChildren.forEach((child, index) => {
                        child.name = this.months[pastYearChildren.length - 1 - index] + " : " + child.children.length + " "+this.$vuetify.lang.t('$vuetify.alarm.alarm') + (child.children.length > 1 ? "s" : "");
                    })
    
                    this.currentYearChildren = currentYearChildren;
                    this.pastYearChildren = pastYearChildren;
                    this.oldChildren = oldChildren;

                    this.currentYearChildrenFiltered = currentYearChildren;
                    this.pastYearChildrenFiltered = pastYearChildren;
                    this.oldChildrenFiltered = oldChildren;

                    this.alarms = alarms;
                    await this.$nextTick();
                    this.updateFiltersSelectedWithQuery();
                }
            } catch(err) {
                console.error(err);
            }
        },
        updateFiltersSelectedWithQuery() {
            let selection = [];
            for (const [key, value] of Object.entries(this.$route.query)) {
                let bool = (value === 'true');
                for (const filter of this.filters) {
                    if ((key === filter.key) && (bool === filter.value)) {
                        selection.push(String(this.filters.indexOf(filter)))
                        break;
                    }
                }
            }
            this.filtersSelected = selection;
        },
        async onUpdateActive() {
            if (this.selected) {
                await this.openFolder(this.selected);
            } else {
                this.active = [];
            }
        },
        async openFolder(alarm) {
            window.stop(); // cancel all previous requests currently running
            this.folderLoading = true;
            try {
                const res = await axios.get('images/alarms/'+ alarm.folder+'/'+this.user.orga);
                let images = res.data;
                images.map((image) => {
                    image.loading = true;
                    image.requestEnded = false;
                });
                for (let img of images) {
                    await this.getImageBlob(alarm.folder, img);
                }
                if (images.every(image => image.requestEnded)) this.images = images;
            } catch(error) {
                if (error.code !== "ECONNABORTED") console.error(error);
            }
            this.folderLoading = false;
        },
        async getImageBlob(directory, image) {
            try {
                if (image) { // guard clause to protect when image is undefined : image can be undefined if a new selection of alarm folder is made during an unfinished loading of current folder
                    const res = await axios.get('images/alarms/' + directory + '/' + image.name+'/'+this.user.orga, { responseType: 'blob' });
                    const blob = res.data;
                    const objectUrl = URL.createObjectURL(blob);
                    image.blob = blob;
                    image.arraybuffer = await blob.arrayBuffer();
                    try {
                        image.tiff = tiff.decode(image.arraybuffer);
                    } catch (err) {
                        image.tiff = undefined;
                    }
                    image.url = objectUrl;
                    image.loading = false;
                    image.requestEnded = true;
                }
            } catch(error) {
                if (error.response) { // Responses with error status code (code in 400 or 500)
                    image.requestEnded = true;
                    if (error.response.status !== 404) console.error("Error response :", error.response);
                } else if (error.request) { // No answer to request : can be triggered manually if request is aborted for example (window.stop())
                    if (error.code !== "ECONNABORTED") console.error("Error request :", error.request);
                } else {
                    console.error("Error message :", error.message);
                }
            }
        },
    }
}
</script>
